import { Http, Headers, Response } from '@angular/http';
import { Injectable } from '@angular/core';
import * as Config from "../../app/app.config";
import {AuthProvider} from "../auth/auth";

/*
  Generated class for the UploadingProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class UploadingProvider {

  constructor(
    public http: Http,
    private auth: AuthProvider
              ) {
    console.log('Hello UploadingProvider Provider');
  }

  public uploadFormData(formData, userId) {
    let that = this;
    let headers = that.auth.createApplicationHeadersWithBearer();
    return this.http.post(Config.baseUrl + '/users/me/documentfile/' + userId, formData
    , { headers: headers })
      .map((res: Response) => res.json());
  }

  public listFiles(userId){
    let that = this;
    let headers = that.auth.createApplicationHeadersWithBearer();
    return this.http.get(Config.baseUrl + '/users/me/getfiles/' + userId, { headers: headers})
      .map((res: Response) => res.json());
  }

  public listCertificationsFiles(userId){
    let that = this;
    let headers = that.auth.createApplicationHeadersWithBearer();
    return this.http.get(Config.baseUrl + '/users/me/getcertificationsfiles/' + userId, { headers: headers})
      .map((res: Response) => res.json());
  }

  public uploadFormCertificationData(formData, userId) {
    let that = this;
    let headers = that.auth.createApplicationHeadersWithBearer();
    return this.http.post(Config.baseUrl + '/users/me/certificationfile/' + userId, formData
      , { headers: headers })
      .map((res: Response) => res.json());
  }

  public removeCertificationFile(fileId) {
    let that = this;
    let headers = that.auth.createApplicationHeadersWithBearer();
    return this.http.get(Config.baseUrl + '/users/me/removecertificationfile/' + fileId, { headers: headers })
      .map((res: Response) => res.json());
  }

  public listContinuousImprovementFiles(userId){
    let that = this;
    let headers = that.auth.createApplicationHeadersWithBearer();
    return this.http.get(Config.baseUrl + '/users/me/getcontinuousimprovementfiles/' + userId, { headers: headers})
      .map((res: Response) => res.json());
  }

  public uploadFormContinuousImprovementData(formData, userId) {
    let that = this;
    let headers = that.auth.createApplicationHeadersWithBearer();
    return this.http.post(Config.baseUrl + '/users/me/continuousimprovementfile/' + userId, formData
      , { headers: headers })
      .map((res: Response) => res.json());
  }

  public listTitlesFiles(userId){
    let that = this;
    let headers = that.auth.createApplicationHeadersWithBearer();
    return this.http.get(Config.baseUrl + '/users/me/gettitlesfiles/' + userId, { headers: headers})
      .map((res: Response) => res.json());
  }

  public uploadFormTitleData(formData, userId) {

    console.log('POST TITLES')
    console.log(formData)

    let that = this;
    let headers = that.auth.createApplicationHeadersWithBearer();
    return this.http.post(Config.baseUrl + '/users/me/titlefile/' + userId, formData
      , { headers: headers })
      .map((res: Response) => res.json());
  }

  public removeTitleFile(fileId) {
    let that = this;
    let headers = that.auth.createApplicationHeadersWithBearer();
    return this.http.get(Config.baseUrl + '/users/me/removetitlefile/' + fileId, { headers: headers })
      .map((res: Response) => res.json());
  }  
}



// WEBPACK FOOTER //
// ./src/providers/uploading/uploading.ts